import Vue from "vue";
import VueRouter from "vue-router";
import Register from "../views/Register.vue";
import Luck from "../views/Luck.vue";
import Index from "../views/Home.vue";
import Turn from "../views/Turn.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: Index
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/luck",
    name: "luck",
    component: Luck
  },
  {
    path: "/turn",
    name: "turn",
    component: Turn
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
